'use strict';
import FetchData from '@ezviz/FetchData';
export const GET_REPLY_MSG_LIST = 'GET_REPLY_MSG_LIST';
export const UPDATE_PROBLEM_MODAL = 'UPDATE_PROBLEM_MODAL';
export const UPDATE_PROBLEM_MODAL_LOADING_STATUS = 'UPDATE_PROBLEM_MODAL_LOADING_STATUS';

// 更新弹出框状态（显示、隐藏）
export function updateProblemModal(modalItme = null, visible = false) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_PROBLEM_MODAL,
      modalItme,
      visible,
    });
  }
}

export function getReplyMsgList(params={}) {
  return (dispatch, getState) => {
    const { recordId='' ,current = 1, pageSize= 10 } = params;
    const defaultParam = {
      recordId,
      // pageStart: parseInt(current) - 1,
      // pageSize: parseInt(pageSize),
    };
    dispatch(updateLoadingStatus(true));
    const url = '/iot/config/api/iot/feedback/replyMsg';
    const fetchData = new FetchData(url, {
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: "POST",
      body: defaultParam,
      metaHandler: {
        403: () => {window.location.href = '/authrization/login'; return;}
      },
    });
    fetchData
      .then(res => {
        dispatch(updateLoadingStatus(false));
        const { meta } = res;
        if (meta.code === 200) {
          const {
            data = {
              list: [],
              total: 0
            }
          } = res;
          let initList = [];
          if(current !== 1) {
            const { replyMsgList } = getState().problemDetail;
            initList = replyMsgList
          }
          dispatch({
            type: GET_REPLY_MSG_LIST,
            replyMsgList: initList.concat(data.list),
            total: data.total,
            current,
          });
        }
      })
      .catch(e => {
        dispatch(updateLoadingStatus(false));
      });
  };
}

export function problemReply(params={}, callback, failback) {
  return (dispatch, getState) => {
    const defaultParam = {
      recordId: '',
      replyType: '0',//1-用户回复, 0-官方回复
      msg: '',
    };
    const url = '/iot/config/api/iot/feedback/reply';
    const fetchData = new FetchData(url, {
      headers: {
        // 'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: "POST",
      body: Object.assign({}, defaultParam, params),
      metaHandler: {
        403: () => {window.location.href = '/authrization/login'; return;}
      },
    });
    fetchData
      .then(res => {
        const { meta } = res;
        if (meta.code === 200) {
          callback && callback();
        } else {
          failback && failback();
        }
      })
      .catch(e => {
        failback && failback();
      });
  };
}

export function updateLoadingStatus(loadingProblemList) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_PROBLEM_MODAL_LOADING_STATUS,
      loadingProblemList,
    });
  }
}
